export default "__VITE_ASSET__cPsd6Ifb__"